import { useQuery } from "@tanstack/react-query";
import type {
  ListMonthlyReportsQuery,
} from "@/modules/management/monthly-report/domain/types";
import { monthlyReportApi } from "./client";

export function useMonthlyReportsQuery(
  query: ListMonthlyReportsQuery,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ["management", "monthly-reports", "list", query],
    queryFn: () => monthlyReportApi.list(query),
    enabled: options?.enabled ?? true,
  });
}

export function useMonthlyReportById(id: string | undefined) {
  return useQuery({
    queryKey: ["management", "monthly-reports", id],
    queryFn: () => {
      if (!id) throw new Error("Monthly report id is required");
      return monthlyReportApi.getById(id);
    },
    enabled: !!id,
  });
}
